import { GearIcon } from '@radix-ui/react-icons';
import { IconButton } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonMenu } from 'components/common/menu';
import { IButton } from 'interfaces/i-buttons';
import { RADIX } from 'lib_ts/enums/radix-ui';
import useMiscStore from 'stores/use-misc-store';

export const AnnotatedVideoPlayerControls = (props: IButton) => {
  const replaySettings = useMiscStore((s) => s.replaySettings);
  const { showDetails, showPlateLoc, showStrikeZone, showTracers } =
    replaySettings;

  return (
    <ErrorBoundary identifier="AnnotatedVideoPlayerControls">
      <CommonMenu
        title="Replay Settings"
        trigger={
          <IconButton
            className="btn-floating"
            color={props.color ?? RADIX.COLOR.NEUTRAL}
            size={props.size ?? RADIX.BUTTON.SIZE.XS}
            variant={props.variant ?? RADIX.BUTTON.VARIANT.BORDERLESS}
          >
            {props.icon ?? <GearIcon />}
          </IconButton>
        }
        actions={[
          {
            label: showTracers ? 'Hide Tracers' : 'Show Tracers',
            onClick: () =>
              useMiscStore.getState().setReplaySettings({
                showTracers: !showTracers,
              }),
          },
          {
            label: showStrikeZone ? 'Hide Strike Zone' : 'Show Strike Zone',
            onClick: () =>
              useMiscStore.getState().setReplaySettings({
                showStrikeZone: !showStrikeZone,
              }),
          },
          {
            label: showDetails ? 'Hide Details' : 'Show Details',
            onClick: () =>
              useMiscStore.getState().setReplaySettings({
                showDetails: !showDetails,
              }),
          },
          {
            label: showPlateLoc ? 'Hide Plate Location' : 'Show Plate Location',
            onClick: () =>
              useMiscStore.getState().setReplaySettings({
                showPlateLoc: !showPlateLoc,
              }),
          },
        ]}
      />
    </ErrorBoundary>
  );
};
